<!-- Card Section  -->
<div class="cards-wrapper">
  <ng-container *ngFor="let card of cards">
    <div
      class="card-wrapper"
      [class.top-full-width]="card.layout === JobsAndCareersCardEnum.TOPFULL"
      [class.bottom-full-width]="
        card.layout === JobsAndCareersCardEnum.BOTTOMFULL
      "
    >
      <div class="content-body">
        <h2 class="card-title">{{ card.title }}</h2>

        <p class="card-content">{{ card.content }}</p>
      </div>

      <div class="btn-container">
        <button
          [ngClass]="{
            'link-cta': !(
              card.layout === JobsAndCareersCardEnum.BOTTOMFULL ||
              card.layout === JobsAndCareersCardEnum.TOPFULL
            )
          }"
          (click)="navigate(card.cta_url, card.title)"
        >
          {{ card.cta_title }}
          <img class="button-arrow" src="assets/icons/thin-arrow-blue.svg" />
        </button>
      </div>
    </div>
  </ng-container>
</div>
